module.exports = __webpack_public_path__ + "img/AWD_logo_horizontal_RGB.e429b686.png";